import { useEffect, useState } from "react";
import { http, formatErr } from "../../lib/api";
import { formatDateIT } from "../../lib/labels";
import { toast } from "sonner";

const MODE_LABEL = { fisso: "Compenso fisso a vendita", percentuale: "Percentuale a scaglioni" };

export default function AgentModalita() {
  const [data, setData] = useState(null);
  const [blocked, setBlocked] = useState(false);
  const [mode, setMode] = useState("fisso");
  const [note, setNote] = useState("");

  const load = async () => {
    try { const { data } = await http.get("/crm/me/mode-change"); setData(data); setMode(data.current_mode === "fisso" ? "percentuale" : "fisso"); setBlocked(false); }
    catch (e) { if (e?.response?.status === 403) setBlocked(true); else toast.error(formatErr(e)); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const request = async () => {
    try { await http.post("/crm/me/mode-change", { to_mode: mode, note }); setNote(""); await load(); toast.success("Richiesta inviata all'amministratore."); }
    catch (e) { toast.error(formatErr(e)); }
  };

  if (blocked) return <div data-testid="agent-modalita-blocked" className="max-w-xl mx-auto card-clean p-6 text-center"><h1 className="font-serif text-2xl mb-2">Modalità provvigionale</h1><p className="text-sm text-neutral-600">Disponibile dopo l'attivazione.</p></div>;
  if (!data) return <div className="p-6 text-sm text-neutral-500">Caricamento…</div>;

  return (
    <div data-testid="agent-modalita-page" className="max-w-xl mx-auto">
      <h1 className="font-serif text-3xl mb-4">Modalità provvigionale</h1>
      <div className="card-clean p-5 space-y-2 text-sm">
        {data.confirmed ? (
          <>
            <div>Modalità attuale confermata: <strong data-testid="am-current">{MODE_LABEL[data.current_mode] || data.current_mode}</strong></div>
            <div>Decorrenza: {formatDateIT(data.mode_since)}</div>
            <div>Cambio disponibile dal: <strong>{formatDateIT(data.eligible_at)}</strong></div>
          </>
        ) : (
          <div data-testid="am-preference">Preferenza indicata: <strong>{MODE_LABEL[data.preference] || data.preference || "—"}</strong>. La modalità sarà <strong>confermata dall'amministratore all'attivazione dell'accordo</strong>; fino ad allora non è ancora operativa.</div>
        )}
        {data.pending && <div className="text-amber-700" data-testid="am-pending">Richiesta di cambio in corso verso: {MODE_LABEL[data.pending.to_mode] || data.pending.to_mode}</div>}
      </div>

      <div className="card-clean p-5 mt-4 text-sm" data-testid="am-explain">
        <div className="font-semibold mb-2">Come funzionano le due modalità</div>
        <p className="mb-1"><strong>Compenso fisso a vendita</strong>: un importo fisso riconosciuto per ogni vendita valida (non è uno stipendio mensile).</p>
        <p><strong>Percentuale a scaglioni mensili</strong>: l'aliquota dipende dalle attivazioni valide del mese e si applica a tutte le vendite valide del mese:</p>
        <ul className="list-disc ml-5 mt-1 text-neutral-600">
          <li>1–3 attivazioni valide: <strong>15%</strong></li>
          <li>4–6 attivazioni valide: <strong>20%</strong></li>
          <li>da 7 in su: <strong>25%</strong></li>
        </ul>
        <p className="text-[11px] text-neutral-400 mt-2">La maturazione della provvigione dipende dalla verifica del saldo.</p>
      </div>
      {data.confirmed && !data.pending && (
        <div className="card-clean p-5 mt-4 space-y-3 text-sm" data-testid="am-form">
          <p className="text-neutral-500">Puoi richiedere il cambio solo dopo 12 mesi dall'ultima decorrenza. Le vendite pregresse non vengono modificate; la nuova modalità vale dalle vendite successive.</p>
          <label className="block"><span className="text-[10px] uppercase tracking-widest text-neutral-500 block mb-1">Nuova modalità</span>
            <select value={mode} onChange={(e) => setMode(e.target.value)} data-testid="am-mode" className="w-full px-3 py-2 rounded-md border" style={{ borderColor: "var(--border-silver)" }}>
              <option value="percentuale">Percentuale a scaglioni</option>
              <option value="fisso">Compenso fisso a vendita</option>
            </select></label>
          <input placeholder="Note (opzionale)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="am-note" className="w-full px-3 py-2 rounded-md border" style={{ borderColor: "var(--border-silver)" }} />
          <button onClick={request} disabled={!data.eligible} data-testid="am-request" className="px-4 py-2 rounded-md text-white text-sm disabled:opacity-40" style={{ background: "var(--brand-dark)" }}>{data.eligible ? "Richiedi cambio" : "Non ancora disponibile (12 mesi)"}</button>
        </div>
      )}
    </div>
  );
}
